import { GenericListCall } from "../../components/types/web-types";
import { postRequest, readRequest } from "../../web";
import {
  AlertDataListCallIn,
  ClientListCallIn,
  ShowLocationCallIn,
} from "./store/typesIn";

const resourceUrl = "/api/clients-overview";

const webCalls = {
  readMyClients(payload: GenericListCall) {
    return postRequest<any, ClientListCallIn>(
      `${resourceUrl}/overview`,
      payload
    );
  },

  showLastLocation(clientId: number) {
    return readRequest<ShowLocationCallIn>(
      `${resourceUrl}/location?clientId=${clientId}`
    );
  },

  readAlertSettings(payload: GenericListCall) {
    return postRequest<any, AlertDataListCallIn>(
      `${resourceUrl}/list-alert-settings`,
      payload
    );
  },
};

export default webCalls;
